<template>
  <v-snackbar
    v-model="$store.state.snackbar.isShow"
    :timeout="$store.state.snackbar.timeout"
    :color="$store.state.snackbar.color"
    class="mb-5">
    {{ $store.state.snackbar.text }}

    <v-btn
      v-if="$store.state.snackbar.type === 'reload'"
      text
      @click="reloadPage">
      更新
    </v-btn>
    <v-btn
      v-else
      text
      @click="$store.commit('closeSnackbar');">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  methods: {
    reloadPage: function() {
      location.reload();
    },
  },
};
</script>
